import { render } from "./ContentblockQuote.vue?vue&type=template&id=6ef88ea4&scoped=true&ts=true"
import script from "./ContentblockQuote.ts?vue&type=script&lang=ts"
export * from "./ContentblockQuote.ts?vue&type=script&lang=ts"

import "./ContentblockQuote.scss?vue&type=style&index=0&id=6ef88ea4&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef88ea4"]])

export default __exports__